class RestApi {
	readonly middleUrl: string = "/HardwareServiceLayer";

	//Reads location
	readonly apiRfidSgln: string = this.middleUrl + "/api/Rfid/sgln";

	//Reads voltage
	readonly apiGantryVoltage: string = this.middleUrl + "/api/Gantry/voltage";

	readonly apiGantryStart: string = this.middleUrl + "/api/Gantry/start";

	readonly apiGantryStop: string = this.middleUrl + "/api/Gantry/stop";

	readonly apiHardwareStatus: string = this.middleUrl + "/api/Hardware/Status";

	readonly saveGantryResults: string = "/Gantry/SubmitResults";
}

export const restApi: RestApi = new RestApi();